import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import type { SubscribedCustomerTokenPayloadDto } from '@repo/schema-api-partner';

export const TOKEN_COOKIE_NAME = 'customer-hub:token';
export const LOGIN_METHOD_COOKIE_NAME = 'customer-hub:login-method';

const COOKIE_ATTRIBUTES = { path: '/', sameSite: 'strict' } as const;

export type LoginMethod = 'form' | 'link';

export function getStoredToken(): string | null {
  return Cookies.get(TOKEN_COOKIE_NAME) ?? null;
}

export function getLoginMethod(): LoginMethod | null {
  const loginMethod = Cookies.get(LOGIN_METHOD_COOKIE_NAME);

  return loginMethod === 'form' || loginMethod === 'link' ? loginMethod : null;
}

export function storeSession(token: string, loginMethod: LoginMethod): void {
  Cookies.set(TOKEN_COOKIE_NAME, token, COOKIE_ATTRIBUTES);
  Cookies.set(LOGIN_METHOD_COOKIE_NAME, loginMethod, COOKIE_ATTRIBUTES);
}

export function clearSession(): void {
  Cookies.remove(TOKEN_COOKIE_NAME, COOKIE_ATTRIBUTES);
  Cookies.remove(LOGIN_METHOD_COOKIE_NAME, COOKIE_ATTRIBUTES);
}

export function getCustomerEmail(): string | undefined {
  const token = getStoredToken();

  if (token === null) {
    return undefined;
  }

  try {
    return jwtDecode<SubscribedCustomerTokenPayloadDto>(token).email;
  } catch {
    return undefined;
  }
}
